import React from "react";
import { HStack, Text } from "@chakra-ui/react";

interface DataLabelProps {
  text: string;
  data: string;
}

const DataLabel: React.FC<DataLabelProps> = (props) => {
  const { text, data } = props;
  return (
    <HStack>
      <Text fontSize="sm" color="gray.500" display="inline-block">
        {text + ":"}
      </Text>
      <Text fontSize="sm">{data}</Text>
    </HStack>
  );
};

export default DataLabel;
